import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogService, NbDialogRef, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { Projet } from '../../../shared/data/projet';
import { plainToClass } from 'class-transformer';
import { Img } from '../../../shared/data/img';
import { Config } from '../../../config/config';

@Component({
  selector: 'ngx-edit-projet',
  templateUrl: './edit-projet.component.html',
  styleUrls: ['./edit-projet.component.scss']
})
export class EditProjetComponent implements OnInit {
  @Input() id: number;
  model;
  /* description;
  slug;
  titre;
  datePublish; 
  heure = "15";
  minute = "22";*/
  projet= new Projet;
  hideButon = false;
  hideLoader = true;
  imageTab:Img[] =[];
  tableau:any =[];
  isPublish = false;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  config = Config;

  categories: any[];

  imageselect = '';
  
  constructor(private sanitizer: DomSanitizer,private dialogService: NbDialogService,protected dialogRef: NbDialogRef<EditProjetComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService ) { 
  
    this.model = this.projet.converDatePublishToNgbDateStruct;

    this.getCategories();
  
  }

  getCategories(){

    this.apiService.getAllCategoryProvider('projet').subscribe(data =>{
     

      this.categories = data as any[];
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })
    
  }

  ngOnInit() {
  
    if(this.id !== 0)
    this.getOneProjet();

    // console.log(this.model);
  
    this.sendeurService.image.asObservable().subscribe(data =>{

      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);

      // console.log(this.imageselect);

      if( this.imageselect === 'photo') {

        this.projet.photo = data;

      }

      if( this.imageselect === 'images') {


        if( this.projet.images !== undefined && this.projet.images !== null){

          const itemIndexPr = this.projet.images.findIndex(item => item.url === data.url);

          if ( itemIndexPr === -1 ) {
            // this.projet.photo = data;
            this.projet.images.push(data);
            // console.log(this.projet);
          }

        } else {

          this.projet.images = []
          this.projet.images.push(data);
        }

        this.imageTab = plainToClass( Img, this.projet.images);
       

      }


    })
   
  }

  delete(img: Img) {
    
    const itemIndex = this.projet.images.findIndex(item => item.url === img.url);
    if ( itemIndex > -1 ) {
      this.projet.images.splice(itemIndex, 1);
      this.imageTab = plainToClass( Img, this.projet.images);
    }

    // console.log( this.projet.images );

    // alert('');

  }

  updatePage(){
  
    if (this.projet.photo === undefined || this.projet.photo === null) {
      this.toastr.danger(" vous devez choisir une image");
      return false;
    }

    
    if(this.model!== undefined){
      this.projet.date_publish = {
        "date": {
            "year": this.model.year,
            "month": this.model.month,
            "day": this.model.day 
        },
        "time": {
          "hour": 0,
          "minute": 0
        }
     } 
    } else {

      this.projet.date_publish = null;

    }

    // console.log ( pro)

    this.hideButon = true;
    this.hideLoader = false;

    if(this.id !== 0) {

        this.apiService.updateProjetProvider(this.projet).subscribe(data =>{
          console.log(data);
          this.dialogRef.close();
          this.sendeurService.fichier.next(null);
          this.toastr.success("mise à jour réussie","success");
          localStorage.removeItem("fichier");
          this.sendeurService.sendPageEvent(6);
        },(err) =>{
          console.log(err);
          this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
          this.hideButon = false;
          this.hideLoader = true;
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

          if(err.error.code ===500){
            
              this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
          }
        })

      } else {

        this.apiService.addProjetProvider(this.projet).subscribe(data =>{
            console.log(data);
            this.dialogRef.close();
            this.toastr.success("projet crée avec success", "success");
            localStorage.removeItem("fichier");
            this.sendeurService.fichier.next(null);
            // this.sendeurService.sendImage('');
            this.sendeurService.sendPageEvent(5);
          },(err) =>{
          this.hideButon = false;
          this.toastr.danger("il se peut qu'un projet porte déjà le meme nom", "erreur")
            console.log(err);
      
            if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

      });

  }
  
  
  }


  addImage(){
  
    localStorage.setItem("photo","fichier");
    this.imageselect = 'photo';
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  addImages(){
    this.tableau= [];
    // localStorage.setItem("photo","image");
    // this.image = true;
    this.imageselect = 'images';
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }


  getOneProjet(){
    this.apiService.getOneProjetProvider(this.id).subscribe(data =>{

      this.projet = plainToClass( Projet, data as object);
      this.model = this.projet.converDatePublishToNgbDateStruct;

      this.imageTab = plainToClass( Img, this.projet.images);

      this.selectedItems = this.projet.categories;

    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

  onItemSelect(item: any) {

    if( this.projet.categories !== undefined){

      let itemIndex: number;
      itemIndex = this.projet.categories.findIndex(itm => itm.id === item.id);

      if (itemIndex === -1)
      this.projet.categories.push(item);

    } else {

      this.projet.categories= [];
      this.projet.categories.push(item);
      
    }

   
  }

  
  onItemDeSelect(item: any){

    let itemIndex: number;
    itemIndex = this.projet.categories.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.projet.categories.splice(itemIndex, 1);

  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }


  cancel(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
    
  }

  close(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }




}
